import React from 'react';
import Page from '../components/Page';
import { FormattedMessage } from 'react-intl'

const Informacoes = (props) => {
   return(
      <Page view="informacoes" bg="/assets/img/informacoes-bg.jpg">
         <h1><FormattedMessage id="infos.h1"/></h1>
         <h3><FormattedMessage id="infos.h3_1"/></h3>
         <p><FormattedMessage id="infos.p1" values={{
            a: msg => (
               <a className="link" href="https://www.who.int/emergencies/diseases/novel-coronavirus-2019/technical-guidance/health-workers" target="_blank" rel="noopener noreferrer">{msg}</a>
            )
         }}/></p>
         <h2><FormattedMessage id="infos.h2"/></h2>
         <h3><FormattedMessage id="infos.h3_2"/></h3>
         <p><FormattedMessage id="infos.p2" values={{
            a: msg => (
               <a className="link" href="https://www.saude.gov.br/saude-de-a-z/ouvidoria-do-sus" target="_blank" rel="noopener noreferrer">{msg}</a>
            )
         }} /></p>
         <h3><FormattedMessage id="infos.h3_3"/></h3>
         <p><FormattedMessage id="infos.p3" values={{
            a: msg => (
               <a className="link" href="https://mpt.mp.br/pgt/servicos/servico-denuncie" target="_blank" rel="noopener noreferrer">{msg}</a>
            )
         }}/></p>
         <h3><FormattedMessage id="infos.h3_4"/></h3>
         <p><FormattedMessage id="infos.p4" values={{
            a: msg => (
            <a className="link" href="https://www.gov.br/acessoainformacao/pt-br" target="_blank" rel="noopener noreferrer">{msg}</a>
            )
         }}/></p>
         <h3><FormattedMessage id="infos.h3_5"/></h3>
         <p><FormattedMessage id="infos.p5" values={{
            a: msg => (
               <a className="link" href="https://www.rededeapoiopsicologico.org.br" target="_blank" rel="noopener noreferrer">{msg}</a>
            )
         }}/></p>
         <h3><FormattedMessage id="infos.h3_6"/></h3>
         <p><FormattedMessage id="infos.p6" values={{
            a: msg => (
               <a className="link" href="https://coronavirus.saude.gov.br/saude-e-seguranca-do-trabalhador-epi" target="_blank" rel="noopener noreferrer">{msg}</a>
            )
         }}/></p>
         <p><FormattedMessage id="infos.p7" values={{
            a: msg => (
               <a className="link" href="https://registrarh-saude.dataprev.gov.br/" target="_blank" rel="noopener noreferrer">{msg}</a>
            )
         }}/></p>
         <h2><FormattedMessage id="infos.h2_2"/></h2>
         <h3><FormattedMessage id="infos.h3_7"/></h3>
         <p><a className="link" href="https://sedac.ciesin.columbia.edu/mapping/viewer" target="_blank" rel="noopener noreferrer">https://sedac.ciesin.columbia.edu/mapping/viewer</a></p>
         <p><a className="link" href="https://coronavirus.jhu.edu/map.html" target="_blank" rel="noopener noreferrer">https://coronavirus.jhu.edu/map.html</a></p>
      </Page>
   )
}

export default Informacoes;
